import { render, staticRenderFns } from "./ObjektiCard2Tab-5-Stalci2.vue?vue&type=template&id=2477f124&scoped=true&"
import script from "./ObjektiCard2Tab-5-Stalci2.vue?vue&type=script&lang=ts&"
export * from "./ObjektiCard2Tab-5-Stalci2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2477f124",
  null
  
)

export default component.exports